import { AddCircle, RemoveCircle } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import React, { FC, useCallback } from 'react';
import { ClientJobFunctionSelect } from '../../../../../../Components/CommonInputs';

export interface IJobFunctionAssignmentInputProps {
    jobFunctionIds: string[];
    handleJobFunctionIdsChange: (jobFunctionIds: string[]) => void;
}

export const JobFunctionAssignmentInput: FC<IJobFunctionAssignmentInputProps> = ({ jobFunctionIds, handleJobFunctionIdsChange }) => {
    const addJobFunctionToAssign = useCallback(() => {
        handleJobFunctionIdsChange([...jobFunctionIds, '']);
    }, [jobFunctionIds, handleJobFunctionIdsChange]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography>Which (if any) Job Functions should be assigned in this step?</Typography>
            {jobFunctionIds.map((jobFunctionId, index) => {
                return (
                    <Box key={index} display='flex' gap={1} alignItems='center'>
                        <ClientJobFunctionSelect
                            selectedJobFunctionId={jobFunctionId}
                            handleSelectedJobFunctionChange={(selectedJobFunction) => {
                                const newJobFunctionIds = [...jobFunctionIds];
                                newJobFunctionIds[index] = selectedJobFunction?.id ?? '';
                                handleJobFunctionIdsChange(newJobFunctionIds);
                            }}
                            jobFunctionsMustHaveUsers
                            hideLabel
                            inMemoryFilter={(jobFunction) => jobFunction.id === jobFunctionId || !jobFunctionIds.includes(jobFunction.id)}
                        />
                        <Box>
                            <IconButton color='error' onClick={() => handleJobFunctionIdsChange(jobFunctionIds.filter((_, i) => i !== index))}>
                                <RemoveCircle />
                            </IconButton>
                        </Box>
                    </Box>
                );
            })}
            <Box>
                <IconButton color='primary' onClick={addJobFunctionToAssign}>
                    <AddCircle />
                </IconButton>
            </Box>
        </Box>
    );
};
